export default __webpack_public_path__ + "static/media/WIN-BNB.ecf87598.svg";